<template>
  <div v-if="!showLearnMore">
    <div
      v-if="transitionFeedbackData.length > 0"
      class="flex flex-col h-full content-start space-y-5"
    >
      <div class="flex flex-col space-y-5 flex-1 w-full">
        <div class="w-full flex justify-between items-end">
          <div class="flex space-x-1 items-center">
            <v-tooltip location="top">
              <template v-slot:activator="{ props }">
                <Icon v-bind="props" icon="ant-design:info-circle" class="text-xl cursor-pointer" />
              </template>
              <div class="w-40 whitespace-normal text-center">
                Click each card to show specific feedback.
              </div>
            </v-tooltip>
            <span class="font-semibold text-sm 2xl:text-base">Select a card</span>
          </div>

          <v-btn
            @click="showLearnMore = true"
            variant="flat"
            class="!py-3 !bg-primary-main !ml-auto !rounded-xl !tracking-normal !capitalize !text-white !h-auto"
          >
            Learn more
          </v-btn>
        </div>

        <TransitionDropdown
          v-for="item in transitionFeedbackData"
          :key="item.id"
          :elemid="item.id"
          :paragraphs="item.paragraphs"
          :category="item.category"
          :type="item.type"
          :suggestions="transitionSuggestions"
          :is-open="selectedTransition === item.id"
          @toggleDropdown="() => onSelectedTransitionChange(item.id)"
          @insertSentence="insertSentence"
          v-on:card-click="selectCardSentence(item.id, item.selectionRange)"
          @click="scrollToElement('.ww-sentence-id' + item.id)"
        />
      </div>
    </div>
    <div v-else class="flex min-h-[70vh] flex-col space-y-6 items-center justify-center">
      <div v-if="loadingBrainResponse" class="flex flex-col space-y-6 items-center">
        <p class="text-xl leading-loose text-center text-black text-opacity-90">
          Loading suggestions
        </p>
      </div>
      <div v-if="!transitionFeedbackData?.length && !loadingBrainResponse">
        <div v-if="functionError">
          <p class="text-xl leading-loose text-center text-black text-opacity-90">
            An error was encountered while running the analysis
          </p>
        </div>
        <div v-else class="flex flex-col space-y-6 items-center justify-center">
          <Icon :icon="'ant-design:check-circle-filled'" color="#52C41A" :height="80" />
          <p class="text-xl leading-loose text-center text-black text-opacity-90">
            Great work!<br />No suggestions found!
          </p>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <TransitionLearnMore @closeLearnMore="showLearnMore = false" />
  </div>
</template>

<script lang="ts">
import TransitionDropdown from '@/components/home/transitions/TransitionDropdown.vue';
import TransitionLearnMore from '@/components/home/transitions/TransitionLearnMore.vue';
import { Icon } from '@iconify/vue';
import { Vue, Options } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { usePayloadStore } from '@/stores/payload';

@Options({
  components: {
    Icon,
    TransitionDropdown,
    TransitionLearnMore
  }
})
export default class Transitions extends Vue {
  @Prop({ required: true })
  private quillEditor!: any;

  @Prop()
  public transitionFeedbackData: any;

  @Prop()
  public transitionSuggestions: any;

  @Prop()
  public highlightedCard: any;
  public selectedTransition = null;
  public showLearnMore = false;

  private payloadStore = usePayloadStore();
  public loadingBrainResponse = this.payloadStore.payload.loadingBrainResponse;
  public functionError = this.payloadStore.payload.functionError;
  @Watch('payloadStore.payload.loadingBrainResponse')
  public onLoadingResponse() {
    this.loadingBrainResponse = this.payloadStore.payload.loadingBrainResponse;
  }

  @Watch('payloadStore.payload.functionError')
  public onFunctionError() {
    this.functionError = this.payloadStore.payload.functionError;
  }

  public onSelectedTransitionChange(val: any) {
    if (val === this.selectedTransition) this.selectedTransition = null;
    else this.selectedTransition = val;
  }

  @Watch('highlightedCard')
  public isHighlightedCard() {
    console.log(this.highlightedCard, 'dgsxccgvjhghvh');
    if (this.highlightedCard == this.selectedTransition) this.selectedTransition = null;
    else this.selectedTransition = this.highlightedCard;
  }

  public insertSentence(sentence: string) {
    this.$emit('insertSentence', sentence, false);
  }

  public selectCardSentence(id: any, selectionRange: any) {
    this.$emit('selectCardSentence', id, selectionRange);
  }

  public scrollToElement(id: any) {
    const elements = this.quillEditor.root.querySelector(`${id}`);
    if (elements) {
      elements.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }
  }
}
</script>
